"use strict";
define('components/two_fa',['components/ajax'], function(ajax) {
    /*
     * Handles Two FA actions
     */

    var twoFA = {

        init: function() {
            this.removeUrlParam('s');
            this.initVerifyBox();
            this.initPhoneInputForm();
            this.initVerificationForm();
        },

        resendSms: function() {
            var userId = $('input[name=user_id]').val(),
                phone = $('input[name=display_phone_number]').val(),
                email = $('input[name=email_address]').val(),
                formData = new FormData();
            formData.append('user_id', userId);
            formData.append('display_phone_number', phone);
            formData.append('email_address', email);
            ajax('/send_token', {
                formData: formData,
                onSuccess: function(result) {
                    $('.resend_2fa_token').addClass('hidden');
                },
                onFailure: function(result) {
                },
                onError: function(result) {
                }
            });
        },

        initVerifyBox: function() {
            var self = this,
                boxContainer = $('#login');
            if (!boxContainer.length) {
                boxContainer = $('#two-fa');
            }
            boxContainer.on('click', '#resend_2fa_token', function(e) {
                e.preventDefault();
                self.resendSms();
            });
        },

        initPhoneInputForm: function() {
            var self = this,
                path = $('input[name=path]'),
                container = $('.phone-input');
            container.on('click', 'button[name=cancel]', function(e) {
                e.preventDefault();
                var urlParts = window.location.href.split('?'),
                    qs = (urlParts.length == 2) ? '?' + urlParts[1] : ''
                window.location.href = (path.val() || '/') + qs;
            });
        },

        initVerificationForm: function() {
            var self = this,
                backRoute = $('input[name=back_route]'),
                container = $('.twofa-verification'),
                loginBox = $('#login');
            if (!loginBox.length) {
                loginBox = $('#two-fa');
            }

            /* We intentionally set the button's type to "button" instead of "submit" on purpose so that this
             * JavaScript file is loaded before the form can be submitted. This is done so that we ensure that
             * users on slow connections have this JavaScript loaded before proceeding.
             *
             * Also, the button may not be present when this JavaScript is loaded, e.g. when the page containing
             * the button is rendered in from an XHR call. And so, we need to add an event handler to the loginBox
             * instead of doing a direct selector like $('button[name=two_fa_submit_button]').
             */
            loginBox.on('click', 'button[name=two_fa_submit_button]', function () {
                $('button[name=two_fa_submit_button]').closest('form').submit();
            });

            container.on('click', 'button.back-button', function(e) {
                e.preventDefault();
                window.location.href = backRoute.val() || '/';
            });
            loginBox.on('submit', 'form.twofa-verify', function(e) {
                if (typeof(FormData) != 'function') {
                    return true;
                }
                // Prevent default browser submit behavior which causes a page refresh and potential race
                // conditions with our request's session object
                e.preventDefault();
                e.stopPropagation();
                var formData = new FormData(e.target);
                $(e.target).find('button')
                           .addClass('disabled').attr('disabled', true)
                           .find('img').removeClass('hidden');
                ajax($(e.target).attr('action'), {
                    formData: formData,
                    onSuccess: function(result) {
                        if (result.location) {
                            return;
                        }
                        $(e.target).find('button').removeClass('disabled')
                                   .attr('disabled', false)
                                   .find('img').addClass('hidden');
                        container.find('form').removeClass('has-error');
                        container.find('form').find('.form-error')
                                 .html('').addClass('hidden');
                    },
                    onFailure: function(result) {
                        var verifyForm = $('form.twofa-verify');
                        $(e.target).find('button').removeClass('disabled')
                                   .attr('disabled', false)
                                   .find('img').addClass('hidden');
                        verifyForm.addClass('has-error');
                        verifyForm.find('.form-error').html(result.form_error)
                                                      .removeClass('hidden');
                    }
                });
            });
        },

        removeUrlParam: function(param) {
            if (!history.pushState) {
                return;
            }
            var url = window.location.href,
                prefix,
                pars;

            // A URL may contain multiple "?"s, and so we want to split at the FIRST "?" only. This is because a
            // redirect URL may contain "?" that's used for preserving query parameters. For example,
            // a valid URL may be "login?path=/lp/investments?status=Active".
            var urlparts = url
                .split(/\?(.+)/)
                .filter(function(x) {  // When using a capturing group, result array contains an empty string at the end
                    return x !== "";
                });

            if (urlparts.length < 2) {
                return;
            }
            prefix = encodeURIComponent(param) + '=';
            pars = urlparts[1].split(/[&;]/g);
            for (var i= pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }
            url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
            window.history.pushState({path: url}, '', url);
        },
    };

    return twoFA;
});

